//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/ugmath.js";
let d=[[],[[["x"],"CreateX",{R_:{r:''}},1,0],[["x","y"],"CreateXY",{R_:{r:''}},2,0],[["x","y","z"],"CreateXYZ",{R_:{r:''}},3,0],[["y","z"],"CreateYZ",{R_:{r:''}},2,0],[["z"],"CreateZ",{R_:{r:''}},1,0],[["m","n"],"Add",{R_:{r:''}},2,0],[["p","m"],"Point",{R_:{q:''}},2,0],[["s","u"],"Scale",{R_:{r:''}},2,0],[["m","n"],"Subtract",{R_:{r:''}},2,0],[["m"],"Transpose",{R_:{r:''}},1,0],[["u","m"],"Vector",{R_:{w:''}},2,0],[["m"],"X",{R_:{w:''}},1,0],[["m"],"Y",{R_:{w:''}},1,0],[["m"],"Z",{R_:{w:''}},1,0]],[]];
SPLM.Matrix3 = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Matrix3";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;